export default function FiveStar({
  className,
}: { className?: string } & React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="112"
      height="22"
      viewBox="0 0 112 22"
      fill="none"
      className={className}
    >
      <path
        d="M9.46896 0.602722L11.5949 7.78707L18.4745 7.78707L12.9088 12.2272L15.0347 19.4116L9.46896 14.9714L3.90324 19.4116L6.02916 12.2272L0.463444 7.78707L7.34304 7.78707L9.46896 0.602722Z"
        fill="currentColor"
      />
      <path
        d="M32.7345 0.602722L34.8604 7.78707L41.74 7.78707L36.1743 12.2272L38.3002 19.4116L32.7345 14.9714L27.1687 19.4116L29.2947 12.2272L23.7289 7.78707L30.6085 7.78707L32.7345 0.602722Z"
        fill="currentColor"
      />
      <path
        d="M56 0.602722L58.1259 7.78707L65.0055 7.78707L59.4398 12.2272L61.5657 19.4116L56 14.9714L50.4342 19.4116L52.5602 12.2272L46.9944 7.78707L53.874 7.78707L56 0.602722Z"
        fill="currentColor"
      />
      <path
        d="M79.2658 0.602722L81.3917 7.78707L88.2713 7.78707L82.7056 12.2272L84.8315 19.4116L79.2658 14.9714L73.7001 19.4116L75.826 12.2272L70.2603 7.78707L77.1399 7.78707L79.2658 0.602722Z"
        fill="currentColor"
      />
      <mask
        id="mask0_2636_36401"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="93"
        y="0"
        width="19"
        height="20"
      >
        <path
          d="M102.531 0.602722L104.657 7.78707L111.537 7.78707L105.971 12.2272L108.097 19.4116L102.531 14.9714L96.9657 19.4116L99.0917 12.2272L93.5259 7.78707L100.406 7.78707L102.531 0.602722Z"
          fill="currentColor"
        />
      </mask>
      <g mask="url(#mask0_2636_36401)">
        <rect x="91" y="-3.39728" width="21" height="26" fill="currentColor" />
      </g>
    </svg>
  );
}
